import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionDiyTokenContainer from "./component";
import { getDiyIntent, setDiyIntent, setHammerSwipe } from "../post-inspection-diy/actions";

const mapStateToProps = () => ({
    postInspectionDiy: {
        purchaseToken: {
            purchaseRequest
        },
        inspectionResponse
    }
}) => ({
    purchaseRequest,
    inspectionResponse
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getDiyIntentConnect: getDiyIntent,
    setDiyIntentConnect: setDiyIntent,
    setHammerSwipeConnect: setHammerSwipe
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyTokenContainer);
